export const MuiSkeleton = {
  defaultProps: {
    // Remove backgroundColor
  },
  styleOverrides: {
    root: {
      backgroundColor: '#1a3746',
    },
  },
  variants: [
    {
      props: {
        variant: 'rectangular',
      },
      style: {
        backgroundColor: '#1a3746',
      },
    },
  ],
}
